module.exports = {
      id: "icon-whatsapp-usage",
      viewBox: "0 0 25.91 25.969",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-whatsapp",
      toString: function () {
        return this.url;
      }
    }